import React from 'react';
import cn from 'classnames';

import StatusBadge from 'shared/ui/Status/StatusBadge';
import badgeStyles from 'shared/ui/Status/StatusBadge.module.scss';
import {PortMonitorStatus} from 'features/port/model/PortMonitor/IPortMonitor';
import {colorPortMonitorState, getPortMonitorStateLabel} from 'features/port/lib/portMonitorHelper';

interface IPortMonitorStateBadgeProps {
    status: PortMonitorStatus,
    ok: boolean | null,
    textOnly?: boolean,
    className?: string,
}

const PortMonitorStateBadge: React.FC<IPortMonitorStateBadgeProps> = ({status, ok, textOnly, className}) => (
    <StatusBadge
        color={colorPortMonitorState(status, ok)}
        label={getPortMonitorStateLabel(status, ok)}
        textOnly={textOnly}
        className={cn(className, textOnly && badgeStyles.forMonitor)}
    />
);

export default PortMonitorStateBadge;
